import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, User, ChevronDown, Menu } from "lucide-react";
import useAuth from "../../auth/useAuth";

function Header({ onMenuClick }) {
  const [profileOpen, setProfileOpen] = useState(false);
  const [, setNotifOpen]     = useState(false);
  const dropdownRef = useRef(null);
  const notifRef    = useRef(null);
  const navigate    = useNavigate();

  // const handleLogout = () => {
  //   localStorage.removeItem("access_token");
  //   navigate("/login");
  // };
  const { logout } = useAuth();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setProfileOpen(false);
      if (notifRef.current    && !notifRef.current.contains(e.target))    setNotifOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sticky top-0 z-10 shadow-sm flex-shrink-0">

      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-xl text-slate-500 hover:bg-slate-100 hover:text-slate-700 transition"
          aria-label="Toggle sidebar"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* <div className="hidden sm:flex items-center gap-2 bg-slate-100 rounded-xl px-3 py-2 w-52 lg:w-72">
          <Search className="w-4 h-4 text-slate-400 flex-shrink-0" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent text-sm text-slate-600 placeholder-slate-400 outline-none w-full"
          />
        </div> */}
      </div>

      <div className="flex items-center gap-1">

     

        <div className="w-px h-6 bg-slate-200 mx-1" />

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setProfileOpen((p) => !p)}
            className="flex items-center gap-2.5 pl-1 pr-2.5 py-1.5 rounded-xl hover:bg-slate-100 transition cursor-pointer"
          >
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
              A
            </div>
            <div className="hidden sm:block text-left">
              <p className="text-sm font-semibold text-slate-700 leading-none">Admin</p>
            </div>
            <ChevronDown
              className={`w-4 h-4 text-slate-400 transition-transform flex-shrink-0 ${
                profileOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {profileOpen && (
            <div className="absolute right-0 mt-2 w-52 bg-white border border-slate-200 rounded-2xl shadow-xl z-50 overflow-hidden">
              <div className="px-4 py-3 border-b border-slate-100">
                <p className="text-sm font-semibold text-slate-700">Admin User</p>
                <p className="text-xs text-slate-400 truncate">admin@example.com</p>
              </div>
              <div className="p-1.5 space-y-0.5">
                <button className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-slate-600 rounded-xl hover:bg-slate-50 transition">
                  <User className="w-4 h-4 text-slate-400" />
                  My Profile
                </button>
                <div className="border-t border-slate-100 my-1" />
                <button
                  onClick={()=>{logout(); navigate("/login");}}
                  className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-red-600 rounded-xl hover:bg-red-50 transition"
                >
                  <LogOut className="w-4 h-4 text-red-400" />
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>

      </div>
    </header>
  );
}

export default Header;